import { pushRoute } from '../../lib/router.js';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import AuthorizedAction from '../../components/AuthorizedAction.js';
import Empty from '../../components/Empty.jsx';
import {
  changeStrategyContent,
  loadingContent,
} from '../../components/EmptyStates.jsx';
import ProjectHeader from '../../components/headers/PageHeaders/Project/ProjectHeader.jsx';
import { PlusButtonIcon } from '../../components/icons/PlusButtonIcon.jsx';

import SubHeader from '../../components/SubHeader.jsx';
import { getOrgTermsContent } from '../../content/utils.js';
import { retrieveProject, selectProject } from '../../modules/projects.js';
import { useFetchFile } from '../../hooks/useFetchFile.js';
import ChangeStrategyActionsDropdown from '../../components/projects/ChangeStrategy/ChangeStrategyActionsDropdown.jsx';
import {
  resetChangeStrategyDraftId,
  retrieveChangeStrategy,
  selectChangeStrategy,
  selectRetrieveChangeStrategyState,
} from '../../modules/changeStrategy.js';
import ChangeStrategyOverview from '../../components/projects/ChangeStrategy/ChangeStrategyOverview/ChangeStrategyOverview.jsx';
import ProjectDetailsHeader from '../../components/headers/PageHeaders/Project/ProjectDetailsHeader.jsx';
import { selectUserPermissions } from '../../modules/auth.js';
import {
  retrieveProjectStatuses,
  selectProjectStatusesWithArchived,
} from '../../modules/projectStatuses.js';
import {
  retrievePortfolios,
  selectPortfolio,
} from '../../modules/portfolio.js';

const mapStateToProps = (state, ownProps) => {
  const project = selectProject(ownProps.projectId)(state);
  return {
    projectId: ownProps.projectId,
    project,
    changeStrategy: selectChangeStrategy(state),
    retrieveChangeStrategyState: selectRetrieveChangeStrategyState(state),
    projectStatuses: selectProjectStatusesWithArchived(state),
    apiUrl: state.config.apiUrl,
    permissions: selectUserPermissions(state),
    portfolio: project?.portfolioId
      ? selectPortfolio(project.portfolioId)(state)
      : null,
  };
};

const mapDispatchToProps = {
  retrievePortfolios,
  retrieveProject,
  retrieveProjectStatuses,
  resetChangeStrategyDraftId,
  retrieveChangeStrategy,
};

const ChangeStrategyContainer = (props) => {
  const {
    slug,
    project,
    changeStrategy,
    retrieveChangeStrategyState,
    retrievePortfolios,
    projectStatuses,
    projectId,
    retrieveProject,
    retrieveChangeStrategy,
    retrieveProjectStatuses,
    resetChangeStrategyDraftId,
    apiUrl,
    portfolio,
  } = props;

  const { loading, downloadBlob } = useFetchFile();

  const onDownloadReport = () => {
    downloadBlob(
      apiUrl,
      `projects/${projectId}/change_strategy_pdf`,
      null,
      'change-strategy-report',
      'pdf'
    );
  };
  const onAddChangeStrategy = () => {
    if (project.archived) {
      window.alert(getOrgTermsContent('archivedProjectMessage'));
    } else {
      resetChangeStrategyDraftId();
      pushRoute('projects/change-strategy/new/step-general', { projectId });
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    retrievePortfolios();
  }, []);

  useEffect(() => {
    retrieveProject(projectId);
    retrieveChangeStrategy(projectId);
    retrieveProjectStatuses();
  }, [projectId]);

  return (
    <React.Fragment>
      <ProjectHeader project={project} />
      <SubHeader flexJustify small>
        <div className="flex">
          <h2>Change Strategy</h2>
        </div>
        <div className="flex flex-1 flex-end">
          {project?.manageProjectEntities ? (
            <div className="flex">
              {!changeStrategy && (
                <AuthorizedAction action="update" subject="project">
                  <Button
                    bsStyle="success"
                    style={{ marginRight: '18px' }}
                    onClick={onAddChangeStrategy}
                  >
                    <PlusButtonIcon />
                    Create Change Strategy
                  </Button>
                </AuthorizedAction>
              )}

              <AuthorizedAction action="update" subject="project">
                <ChangeStrategyActionsDropdown
                  slug={slug}
                  projectId={project.id}
                  project={project}
                  isChangeStrategyExist={project.changeStrategyExists}
                  onDownloadReport={onDownloadReport}
                  isReportLoading={loading}
                />
              </AuthorizedAction>
            </div>
          ) : null}
        </div>
      </SubHeader>
      {project && projectStatuses ? (
        <ProjectDetailsHeader
          portfolio={portfolio}
          project={project}
          changeStrategy={changeStrategy}
          projectStatuses={projectStatuses}
          slug={slug}
          isShowStrategyData
        />
      ) : null}
      {retrieveChangeStrategyState.pending ? (
        <Empty simplified content={loadingContent} />
      ) : project?.changeStrategyExists ? (
        <ChangeStrategyOverview
          project={project}
          changeStrategy={changeStrategy}
        />
      ) : (
        <Empty
          content={changeStrategyContent}
          action={onAddChangeStrategy}
          actionAuthorization={{
            action: project?.manageProjectEntities ? 'create' : null,
            subject: 'stakeholder',
          }}
          addBtn
        ></Empty>
      )}
    </React.Fragment>
  );
};

ChangeStrategyContainer.propTypes = {
  projectId: PropTypes.number.isRequired,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChangeStrategyContainer);
